// A miniature wrapper around local storage so that we're only using it if it exists

// There are at least two places browsers will throw if local-storage is disabled:
// 1. when you dereference window.localStorage
// 2. when you call a method on localStorage

let localStorage: Storage | undefined;
try {
  localStorage = window.localStorage;
} catch (e) {
  localStorage = undefined;
}

const LocalStorageWrapper = {
  setItem(key: string, value: string) {
    try {
      localStorage?.setItem(key, value);
    } catch (e) {
      console.warn(`[APP_ERROR] unable to set key ${key} to value ${value}`);
    }
  },

  getItem(key: string): string | null | undefined {
    try {
      return localStorage?.getItem(key);
    } catch (e) {
      console.warn(`[APP_ERROR] unable to get key ${key}`);
    }
  },

  removeItem(key: string) {
    try {
      return localStorage?.removeItem(key);
    } catch (e) {
      console.warn(`[APP_ERROR] unable to remove key ${key}`);
    }
  },
};

export default LocalStorageWrapper;
